import { EMPOWERING_CONSTANTS } from "./constants";
import { Stack, Text, Heading } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { TEXT_VARIANTS } from "@/theme/components/text";

const EmpoweringComponent = () => {
  const TextVariant = useTextVariants();
  return (
    <Stack align={"center"} justify={"center"}>
      <Stack width={{ base: "100%", md: "60%", lg: "50%" }} spacing={6}>
        <Heading as="h1" fontWeight={"400"} textAlign={"center"} fontSize={"44px"}>
          {EMPOWERING_CONSTANTS.title}
        </Heading>
        <Text
          variant={TEXT_VARIANTS.BODY1}
          fontWeight={600}
          //   fontSize={{base: "16px", md: "18px"}}
          //   lineHeight={"30px"}
          color="text.100"
          textAlign={"center"}
        >
          {EMPOWERING_CONSTANTS.subTitle}
        </Text>
        <Text
          px={8}
          variant={TextVariant}
          color="text.100"
          textAlign={"center"}
          lineHeight={"30px"}
        >
          {EMPOWERING_CONSTANTS.text}
        </Text>
      </Stack>
    </Stack>
  );
};
export default EmpoweringComponent;
